import React, { useEffect, useState } from "react";

import {FaHospitalUser} from 'react-icons/fa';

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName, getUnidadHospitalariaValue} from '../../objects/unidadHospitalaria';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { descrifrar } from '../../utils/functions';

/**
 * Componente que contiene la información y funcionalidad asignada un log de actividad
 * @param {Object} param0 Recibe un objeto de tipo log con su respectiva información y la información de la sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const LogCard = ({log, userLevel, uhList ,nomHospitalUser, setLogSelected, setIsCollapsed}) => {
    
    //Estado que almacena si el paciente corresponde a la unidad hospitalaria del usuario
    const [correspondeHospital,setCorrespondeHospital] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa alta administrativa
    const [isAltaAdministrativa, setIsAltaAdministrativa] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de salida
    const [isCancelacion, setIsCancelacion] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de quirófano
    const [isQuirofano, setIsQuirofano] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de recuperación
    const [isRecuperacion, setIsRecuperacion] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de salida
    const [isSalida, setIsSalida] = useState(false)
    
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleActive = { color: "#84c404", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleAltaAdministrativa = { color: "#04afaa", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes con cirugía cancelada
    const styleCancelacion = { color: "#0582a9", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleComplicacion = { color: "#e12f3b", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleQuirofano = { color: "black", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en recuperación
    const styleRecuperacion = { color: "#FFBF00", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}

    useEffect(()=>{
        if(log){
            if(userLevel === "superuser"){//Verificar si el usuario tiene acceso total a los pacientes
                setCorrespondeHospital(true)
            }
            else{
                let uhName = getUnidadHospitalariaValue(log.paciente.UnidadHospitalaria)

                if(getUnidadHospitalariaName(descrifrar(nomHospitalUser).toString(),uhList) === 
                    getUnidadHospitalariaName(uhName,uhList)){//Se verifica si el paciente pertence a la unidad hospitalaria a la que esta asignado el usuario
                    setCorrespondeHospital(true)
                }
                else{//No corresponde a la misma unidad hospitalaria
                    //Se oculta la tarjeta del paciente
                    setCorrespondeHospital(false)
                }
            }

            if(log.action === "Change status to Recuperacion" || log.action === "Report status to Recuperacion"){
                setIsRecuperacion(true)
                setIsSalida(false)
                setIsQuirofano(false)
                setIsAltaAdministrativa(false)
                setIsCancelacion(false)
            }
            else{
                setIsRecuperacion(false)
                if(log.action === "Change status to Salida" || log.action === "Report status to Salida"){
                    setIsSalida(true)
                    setIsQuirofano(false)
                    setIsAltaAdministrativa(false)
                    setIsCancelacion(false)
                }
                else{
                    setIsSalida(false)
                    if(log.action === "Change status to Quirofano" || log.action === "Report status to Quirofano"){
                        setIsQuirofano(true)
                        setIsAltaAdministrativa(false)
                        setIsCancelacion(false)
                    }
                    else{
                        setIsQuirofano(false)
                        if(log.action === "Report status to Ambulatorio Alta" || log.action === "Report status to Alta Adminitrativa"){
                            setIsAltaAdministrativa(true)
                            setIsCancelacion(false)
                        }
                        else{
                            setIsAltaAdministrativa(false)
                            if(log.action === "Report status to Cancelación"){
                                setIsCancelacion(true)
                            }
                            else{
                                setIsCancelacion(false)
                            }
                        }
                    }
                }
            }
        }
        else{
            
        }
    },[log,userLevel,nomHospitalUser,uhList])

    const handleSalidaClick = (log) => (event) => {
        event.preventDefault()
        setLogSelected(log)
        //setLogTitle(log.paciente.NumeroDePaciente + " " + log.paciente.UnidadHospitalaria + " " + log.action)
        setIsCollapsed(true)
        document.getElementById('log-viewer').style.display='block'
    }

    return (
        <>
            {
                correspondeHospital ?
                    <>
                        <div className="itemblog"  onClick={handleSalidaClick(log)}>
                            <div>
                                {
                                    isRecuperacion?<FaHospitalUser style={styleRecuperacion}/>
                                    :isSalida?<FaHospitalUser style={styleActive}/>
                                    :isQuirofano?<FaHospitalUser style={styleQuirofano}/>
                                    :isAltaAdministrativa?<FaHospitalUser style={styleAltaAdministrativa}/>
                                    :isCancelacion?<FaHospitalUser style={styleCancelacion}/>
                                    :<FaHospitalUser style={styleComplicacion}/>
                                }
                                <h1 className='itemblogTitle'>{log.paciente.NumeroDePaciente.toUpperCase()}</h1>
                                <h1 className='info_item_hospital_name'>{getUnidadHospitalariaName(log.paciente.UnidadHospitalaria,uhList)}</h1>
                                <h1 className='info_itemblog'>Paciente: {log.paciente.patientname}</h1>
                                <h1 className='info_itemblog'>{log.action}</h1>
                                <h1 className='info_item_fecha'>{log.date} {log.time}</h1>
                                <h1 className='info_itemblog'>Realizó: {log.username}</h1>
                            </div>
                        </div>
                    </>
                : null    
            }
        </>
    )
}

export default LogCard;